import './styles/name-description-entity.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const NameDescriptionEntity = ({ title, item, url }) => {
  return (
    <div className="name-description-entity">
      <div className="title">{title}</div>

      <div className="content">
        <div className="name">
          <Link to={url}>{item.name}</Link>
        </div>

        {item.description && <div className="description">{item.description}</div>}
      </div>
    </div>
  )
}
NameDescriptionEntity.propTypes = {
  title: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  url: PropTypes.string,
}
export default NameDescriptionEntity